module.exports = __webpack_public_path__ + "static/img/guide1.e7350e66.png";